import request from "./request";

const api = {
  getUserServerList: "user_server/getUserServerList",
  getIncome: "user_server/getIncome",
};
export default {
  getUserServerList(parameter) {
    return request({
      url: api.getUserServerList,
      method: "POST",
      data: parameter,
    });
  },
  getIncome(parameter) {
    return request({
      url: api.getIncome,
      method: "POST",
      data: parameter,
    });
  },
};
